// async
export const COMMON_SECONDARY_PAGING_PAGING_FETCHING = `COMMON_SECONDARY_PAGING_FETCHING`;
export const COMMON_SECONDARY_PAGING_PAGING_SUCCESS = `COMMON_SECONDARY_PAGING_SUCCESS`;
export const COMMON_SECONDARY_PAGING_PAGING_ERROR = `COMMON_SECONDARY_PAGING_ERROR`;
export const COMMON_SECONDARY_PAGING_PAGING_CLEAR = `COMMON_SECONDARY_PAGING_CLEAR`;

// set parameters for paging
export const COMMON_SECONDARY_PAGING_PAGING_SET_PAGE_SIZE = `COMMON_SECONDARY_PAGING_SET_PAGE_SIZE`;
export const COMMON_SECONDARY_PAGING_PAGING_SET_PAGE_NUMBER = `COMMON_SECONDARY_PAGING_SET_PAGE_NUMBER`;
export const COMMON_SECONDARY_PAGING_PAGING_SET_FILTER = `COMMON_SECONDARY_PAGING_SET_FILTER`;
export const COMMON_SECONDARY_PAGING_PAGING_SET_SORT_COLUMN = `COMMON_SECONDARY_PAGING_SET_SORT_COLUMN`;

// addtional search paramters
export const COMMON_SECONDARY_PAGING_PAGING_SET_SEARCH_PARAMETERS = `COMMON_SECONDARY_PAGING_PAGING_SET_SEARCH_PARAMETERS`;

export const COMMON_SECONDARY_PAGING_PAGING_RESET = `COMMON_SECONDARY_PAGING_RESET`;

export const COMMON_PAGING_PAGING_FETCHING = 'COMMON_PAGING_FETCHING';
export const COMMON_PAGING_PAGING_SUCCESS = 'COMMON_PAGING_SUCCESS';
export const COMMON_PAGING_PAGING_ERROR = 'COMMON_PAGING_ERROR';
export const COMMON_PAGING_PAGING_CLEAR = 'COMMON_PAGING_CLEAR';

// set parameters for paging
export const COMMON_PAGING_PAGING_SET_PAGE_SIZE = 'COMMON_PAGING_SET_PAGE_SIZE';
export const COMMON_PAGING_PAGING_SET_PAGE_NUMBER =
  'COMMON_PAGING_SET_PAGE_NUMBER';
export const COMMON_PAGING_PAGING_SET_FILTER = 'COMMON_PAGING_SET_FILTER';
export const COMMON_PAGING_PAGING_SET_SORT_COLUMN =
  'COMMON_PAGING_SET_SORT_COLUMN';

// addtional search paramters
export const COMMON_PAGING_PAGING_SET_SEARCH_PARAMETERS =
  'COMMON_PAGING_PAGING_SET_SEARCH_PARAMETERS';

export const COMMON_PAGING_PAGING_RESET = 'COMMON_PAGING_RESET';



// WEBPACK FOOTER //
// ./src/state/paging/types.js